import { render, staticRenderFns } from "./PartnerParameters.vue?vue&type=template&id=2b291ea7&scoped=true"
import script from "./PartnerParameters.vue?vue&type=script&lang=ts"
export * from "./PartnerParameters.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b291ea7",
  null
  
)

export default component.exports